module.exports = __webpack_public_path__ + "static/Cambodia-logo-eb836e481c5c2e18057744cac8ef578b.png";